export default function CtaBand() {
  return (
    <section className="bg-primary-500">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground-950/10 font-label text-xs text-foreground-950">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-compass-3-line text-[14px]"></i>
              </span>
              方向不清？先看导览
            </span>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              先看黑料网5特色，再看区别与不同
            </h2>
            <p className="mt-4 font-body text-sm md:text-base text-foreground-900 leading-relaxed">
              入口、对照、标签墙与独立版块都已经排好顺序。从分站入口挑一个方向，或者直接从对照表开始，按自己的节奏把结构读一遍。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#entry"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-foreground-950 text-background-50 font-label text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              从入口开始
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[16px]"></i>
              </span>
            </a>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-950/30 text-foreground-950 font-label text-sm font-medium hover:bg-foreground-950/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              先看常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}